import ListProcesses from "@/views/agro_exporter/finances/container_outcomes/ListProcesses.vue";
import ShowProcess from "@/views/agro_exporter/finances/container_outcomes/ShowProcess.vue";
import ShowProcessContainers from "@/components/views/agro_exporter/finances/container_outcomes/show_process/Containers.vue";
import ShowProcessExportInvoices from "@/components/views/agro_exporter/finances/container_outcomes/show_process/OrgInvoices.vue";
import ShowContainer from "@/views/agro_exporter/finances/container_outcomes/ShowContainer.vue";
import ShowOrgInvoice from "@/views/agro_exporter/finances/container_outcomes/ShowOrgInvoice.vue";
import AssignProvider from "@/views/agro_exporter/finances/container_outcomes/AssignProvider.vue";
import NewOrgInvoice from "@/views/agro_exporter/finances/container_outcomes/NewOrgInvoice.vue";
import EditOrgInvoice from "@/views/agro_exporter/finances/container_outcomes/EditOrgInvoice.vue";
import NewOrgInvoicePayment from "@/views/agro_exporter/finances/container_outcomes/NewOrgInvoicePayment.vue"
import EditOrgInvoicePayment from "@/views/agro_exporter/finances/container_outcomes/EditOrgInvoicePayment.vue"

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "finances",
  permission: "container_outcomes"
});

export default [
  {
    path: "/ae/:agro_exporter_id/finances/container_outcomes/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_outcomes/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_outcomes/show_process/:agro_exporter_process_id",
    name: routeName("show_process"),
    redirect: { name: routeName("show_process_containers") },
    component: ShowProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "containers",
        name: routeName("show_process_containers"),
        alias: "",
        component: ShowProcessContainers,
        props: true
      },
      {
        path: "org_invoices",
        name: routeName("show_process_org_invoices"),
        alias: "",
        component: ShowProcessExportInvoices,
        props: true
      }
    ]
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_outcomes/:agro_exporter_process_id/show_container/:container_id",
    name: routeName("show_container"),
    component: ShowContainer,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_outcomes/:agro_exporter_process_id/show_org_invoice/:org_invoice_id/:container_id",
    name: routeName("show_org_invoice"),
    component: ShowOrgInvoice,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_outcomes/:agro_exporter_process_id/assign_provider/:container_id",
    name: routeName("assign_provider"),
    component: AssignProvider,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_outcomes/:agro_exporter_process_id/new_org_invoice/:container_id",
    name: routeName("new_org_invoice"),
    component: NewOrgInvoice,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_outcomes/:agro_exporter_process_id/edit_org_invoice/:org_invoice_id",
    name: routeName("edit_org_invoice"),
    component: EditOrgInvoice,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_outcomes/:agro_exporter_process_id/new_org_invoice_payment/:org_invoice_id",
    name: routeName("new_org_invoice_payment"),
    component: NewOrgInvoicePayment,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/finances/container_outcomes/:agro_exporter_process_id/edit_org_invoice_payment/:org_invoice_id/:org_invoice_payment_id",
    name: routeName("edit_org_invoice_payment"),
    component: EditOrgInvoicePayment,
    props: true,
    meta: META
  }
];
